export default "__VITE_ASSET__DOehEF6R__"